/**
 * Poptoons · Outlet · guardia del carrito de la tienda regular.
 *
 * Complementa al snippet poptoons-outlet-candado (que pinta el aviso y el marcador
 * [data-pt-outlet-mixed] cuando el carrito mezcla outlet + tienda):
 *   1. frena el submit del checkout mientras el carrito esté mezclado (el CSS apaga
 *      el botón, esto cubre Enter en un input del formulario);
 *   2. resuelve los botones "Quitar los del outlet" / "Quitar los de la tienda".
 * Se carga desde layout/theme.liquid en toda la tienda regular; pesa poco y no hace
 * nada hasta que aparece el marcador.
 */
(function () {
  'use strict';
  if (window.__ptOutletGuard) return;
  window.__ptOutletGuard = true;

  var routes = (window.theme && window.theme.routes) || {};
  var cartUrl = routes.cart || '/cart';
  var updateUrl = routes.cartUpdate || '/cart/update';

  // Las líneas del outlet las decide Liquid (tipo "Outlet" o tag `outlet`) y llegan en
  // data-outlet-keys del aviso; el tipo queda como respaldo.
  function outletKeys() {
    var el = document.querySelector('[data-pt-outlet-mixed]');
    var raw = (el && el.getAttribute('data-outlet-keys')) || '';
    var out = {};
    raw.split(',').forEach(function (k) { if (k) out[k] = true; });
    return out;
  }

  function isOutlet(item, keys) {
    return keys[item.key] === true || String(item.product_type || '').trim().toLowerCase() === 'outlet';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form')) return;
    var submitter = e.submitter;
    var isCheckout = submitter && submitter.name === 'checkout';
    if (!isCheckout) return;
    var mixed = document.querySelector('[data-pt-outlet-mixed]');
    if (!mixed) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    mixed.scrollIntoView({ block: 'center', behavior: 'smooth' });
    mixed.classList.add('is-shaking');
    setTimeout(function () { mixed.classList.remove('is-shaking'); }, 500);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pt-outlet-remove]');
    if (!btn) return;
    e.preventDefault();
    var group = btn.getAttribute('data-pt-outlet-remove');
    btn.disabled = true;
    fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var keys = outletKeys();
        cart.items.forEach(function (i) {
          var out = isOutlet(i, keys);
          if ((group === 'outlet' && out) || (group === 'regular' && !out)) updates[i.key] = 0;
        });
        return fetch(updateUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () {
        // El drawer y la página de carrito se re-renderizan solos al recargar; es lo
        // más simple y deja el estado exactamente como Liquid lo ve.
        if (group === 'regular') window.location.href = '/checkout';
        else window.location.reload();
      })
      .catch(function () { btn.disabled = false; });
  });
})();
